// extracted by mini-css-extract-plugin
module.exports = {"button":"install-app-button__button___1Y9QY"};